import React from 'react';

function ProductForm({ formData, handleChange, handleSubmit, categories, titresOptions }) {
  return (
    <form onSubmit={handleSubmit} encType="multipart/form-data">
      {/* Catégorie */}
      <div>
        <select
          name="categorie_id"
          value={formData.categorie_id || ''}
          onChange={handleChange}
          required
          style={{ width: '100%' }}
        >
          <option value="">-- Choisir une catégorie --</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>{cat.categorie}</option>
          ))}
        </select>
      </div>

      {/* Titre */}
      <div>
        <select
          name="titre_id"
          value={formData.titre_id || ''}
          onChange={handleChange}
          required
          style={{ width: '100%' }}
        >
          <option value="">-- Choisir un titre --</option>
          {titresOptions.map((titre) => (
            <option key={titre.id} value={titre.id}>{titre.title}</option>
          ))}
        </select>
      </div>

      {/* Description courte */}
      <input
        name="description"
        placeholder="Courte description"
        value={formData.description}
        onChange={handleChange}
        required
      />

      {/* Description détaillée */}
      <textarea
        name="description_detaillee"
        placeholder="Description détaillée"
        value={formData.description_detaillee}
        onChange={handleChange}
        required
      />

      {/* Prix + Unité (même ligne) */}
      <div style={{ display: 'flex', gap: '10px' }}>
        <input
          name="price"
          type="number"
          min="1"
          placeholder="Prix (Ar)"
          value={formData.price}
          onChange={handleChange}
          required
          style={{ flex: 1 }}
        />
        <select
          name="unite"
          value={formData.unite}
          onChange={handleChange}
          required
          style={{ flex: 1 }}
        >
          {/* <option value="">-- Unité --</option> */}
          <option value="kg">Kilogrammes (kg)</option>
          <option value="sac">Sac</option>
          <option value="tonne">Tonne</option>
        </select>
      </div>

      {/* Stock */}

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            name="stock"
            type="number"
            min="1"
            placeholder="Stock"
            value={formData.stock}
            onChange={handleChange}
            required
            style={{ flex: 1 }}
          />
          <span style={{ color: '#555' }}>{formData.unite || 'kg'}</span>
        </div>
        
      {/* <input
        name="stock"
        type="number"
        min="1"
        placeholder="Stock disponible"
        value={formData.stock}
        onChange={handleChange}
        required
      /> */}

      {/* Lieu */}
      <input
        name="lieu"
        placeholder="Lieu de provenance"
        value={formData.lieu}
        onChange={handleChange}
        required
      />

      {/* Quantité minimale */}
      <input
        name="quantite_min"
        type="number"
        min="1"
        placeholder="Quantité minimale à commander"
        value={formData.quantite_min}
        onChange={handleChange}
        required
      />

      {/* Image */}
      <label>Image du produit :</label>
      <input
        name="img"
        type="file"
        accept="image/*"
        onChange={handleChange}
        required
      />

      {/* Aperçu image */}
      {formData.img && typeof formData.img === 'object' && (
        <div style={{ marginTop: '10px' }}>
          <p>Image sélectionnée :</p>
          <img
            src={URL.createObjectURL(formData.img)}
            alt="Aperçu du produit"
            style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px' }}
          />
        </div>
      )}

      <button type="submit" className="btn-enregistrer">Enregistrer</button>
    </form>
  );
}

export default ProductForm;
